// import React, {useState, useEffect} from 'react';
// import {useTranslation} from "react-i18next";
// import {useDispatch, useSelector} from "react-redux";
// import {productsActions} from "../../../../store/slices/settings-slices";
//
// import css from './ModalExcludedProduct.module.css';
//
// const ModalExcludedProduct = ({setSelectedMeals, setSelectedIds, selectedMeals}) => {
//     const [dropdownOpen, setDropdownOpen] = useState(false);
//     const [searchQuery, setSearchQuery] = useState('');
//     const {t} = useTranslation();
//     const dispatch = useDispatch();
//     const {productsArray, trigger} = useSelector(store => store.products);
//
//
//     console.log('productsArrayFromExclud',productsArray);
//
//     useEffect(() => {
//         dispatch(productsActions.getAllProducts());
//     }, [trigger]);
//
//     // Log the selected meals for debugging
//     useEffect(() => {
//         console.log('Selected meals:', selectedMeals);
//     }, [selectedMeals]);
//
//     const excludableProducts = productsArray?.filter(product => product.excludable) || [];
//
//     const filteredProducts = excludableProducts.filter(product =>
//         product.name?.en?.toLowerCase().includes(searchQuery.toLowerCase()) ||
//         product.name?.ru?.toLowerCase().includes(searchQuery.toLowerCase()) ||
//         product.name?.ge?.toLowerCase().includes(searchQuery.toLowerCase())
//     );
//
//     const handleMealSelect = (event) => {
//         const options = Array.from(event.target.selectedOptions);
//         const newSelected = options.map((option) => {
//             const product = excludableProducts.find((meal) => meal.id === option.value);
//             return {
//                 id: option.value,
//                 name: product.name,
//             };
//         });
//
//         console.log('New selected products:', newSelected);
//
//         setSelectedMeals((prev) => {
//             const existingIds = prev.map((meal) => meal.id);
//             const uniqueNew = newSelected.filter((meal) => !existingIds.includes(meal.id));
//             return [...prev, ...uniqueNew];
//         });
//
//         setSelectedIds((prev) => {
//             const newIds = options.map((option) => option.value);
//             const updatedIds = Array.from(new Set([...prev, ...newIds]));
//             console.log('Updated selected IDs:', updatedIds);
//             return updatedIds;
//         });
//
//         setDropdownOpen(false);
//     };
//
//     const removeMeal = (mealId) => {
//         setSelectedMeals((prev) => prev.filter((meal) => meal.id !== mealId));
//         setSelectedIds((prev) => prev.filter((id) => id !== mealId));
//     };
//
//     return (
//         <section className={css.row}>
//             <div className={css.inputGroup}>
//                 <label htmlFor="availableMeals">{t('excluded-products')}</label>
//                 <div className={css.customSelect}>
//                     <div
//                         className={css.selectedOptions}
//                         onClick={() => setDropdownOpen(!dropdownOpen)}
//                     >
//                         {selectedMeals.length > 0
//                             ? selectedMeals.map((meal) => (
//                                 <span key={meal.id} className={css.optionTag}>
//                                     {meal.name.en}
//                                     <button
//                                         type="button"
//                                         onClick={(e) => {
//                                             e.stopPropagation();
//                                             removeMeal(meal.id);
//                                         }}
//                                         className={css.removeButton}
//                                     >
//                                         &times;
//                                     </button>
//                                 </span>
//                             ))
//                             : t("Select excluded products")}
//                     </div>
//                     {dropdownOpen && (
//                         <div className={css.dropdownContent}>
//                             <input
//                                 type="text"
//                                 className={css.searchInput}
//                                 placeholder={t("Search products...")}
//                                 value={searchQuery}
//                                 onChange={(e) => setSearchQuery(e.target.value)}
//                             />
//                             <select
//                                 id="availableMeals"
//                                 multiple
//                                 onChange={(e) => handleMealSelect(e)}
//                                 className={css.select}
//                             >
//                                 {filteredProducts.map((item) => (
//                                     <option
//                                         key={item.id}
//                                         value={item.id}
//                                         disabled={selectedMeals.some(meal => meal.id === item.id)}
//                                     >
//                                         {item.name.en}
//                                     </option>
//                                 ))}
//                             </select>
//                         </div>
//                     )}
//                 </div>
//             </div>
//         </section>
//     );
// };
//
// export {ModalExcludedProduct};

import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import { productsActions } from "../../../../store/slices/settings-slices";
import css from "./ModalExcludedProduct.module.css";

const ModalExcludedProduct = ({
  setSelectedMeals,
  setSelectedIds,
  selectedMeals,
}) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const dispatch = useDispatch();
  const { productsArray, trigger } = useSelector((store) => store.products);

  const { i18n, t } = useTranslation();
  const currentLanguage = i18n.language;

  useEffect(() => {
    if (trigger !== undefined) {
      dispatch(productsActions.getAllProducts());
    }
  }, [trigger, dispatch]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (!e.target.closest(`.${css.customSelect}`)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const excludableProducts =
    productsArray?.filter((product) => product.excludable) || [];

  const filteredProducts = excludableProducts.filter(
    (product) =>
      product.name?.en?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      product.name?.ru?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      product.name?.ge?.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const handleMealSelect = (event) => {
    const options = Array.from(event.target.selectedOptions);
    const newSelected = options
      .map((option) => {
        const product = excludableProducts.find(
          (meal) => meal.id === option.value
        );
        if (!product) return null;
        return {
          id: option.value,
          name: product.name,
        };
      })
      .filter(Boolean);

    setSelectedMeals((prev) => {
      const existingIds = prev.map((meal) => meal.id);
      const uniqueNew = newSelected.filter(
        (meal) => !existingIds.includes(meal.id)
      );
      return [...prev, ...uniqueNew];
    });

    setSelectedIds((prev) => {
      const newIds = options.map((option) => option.value);
      const updatedIds = Array.from(new Set([...prev, ...newIds]));
      return updatedIds;
    });

    setDropdownOpen(false);
  };

  const removeMeal = (mealId) => {
    setSelectedMeals((prev) => prev.filter((meal) => meal.id !== mealId));
    setSelectedIds((prev) => prev.filter((id) => id !== mealId));
  };

  return (
    <section className={css.row}>
      <div className={css.inputGroup}>
        <label htmlFor="availableMeals">{t("excluded-products")}</label>
        <div className={css.customSelect}>
          <div
            className={css.selectedOptions}
            onClick={() => setDropdownOpen(!dropdownOpen)}
          >
            {selectedMeals.length > 0
              ? selectedMeals.map((meal) => (
                  <span key={meal.id} className={css.optionTag}>
                    {meal.name.en}
                    <button
                      type="button"
                      onClick={(e) => {
                        e.stopPropagation();
                        removeMeal(meal.id);
                      }}
                      className={css.removeButton}
                    >
                      &times;
                    </button>
                  </span>
                ))
              : t("Select excluded products")}
          </div>
          {dropdownOpen && (
            <div className={css.dropdownContent}>
              <input
                type="text"
                className={css.searchInput}
                placeholder={t("Search products...")}
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
              <select
                id="availableMeals"
                multiple
                onChange={handleMealSelect}
                className={css.select}
              >
                {filteredProducts.map((item) => (
                  <option
                    key={item.id}
                    value={item.id}
                    disabled={selectedMeals.some((meal) => meal.id === item.id)}
                    className={
                      selectedMeals.some((meal) => meal.id === item.id)
                        ? css.disabledOption
                        : ""
                    }
                  >
                    {item.name[currentLanguage]}
                  </option>
                ))}
              </select>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export { ModalExcludedProduct };
